import '@pages/Employees/AddEmployee/components/styles/AddEmployeePageHeader.desktop.scss';
import '@pages/Employees/AddEmployee/components/styles/AddEmployeePageHeader.tablet.scss';

export const AddEmployeePageHeader = () => {
  return <div className="add-employee-header"></div>;
};
